import * as React from 'react';
import { Tab, Tabs, Stack, Box, Typography, Card } from '@mui/material';
import { styled } from '@mui/material/styles';
import EditProfile from './EditProfile';
import ViewProfile from './ViewProfile';

const CenteredBox = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ mt: 2 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function Details({ admin, onFetchAdmin }) {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <>
            <Card
                sx={{ p: 4, height: "100%" }}>
                <CenteredBox sx={{ width: '100%' }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        textColor="secondary"
                        aria-label="secondary tabs example"
                        TabIndicatorProps={{ style: { display: 'none' } }}
                        sx={{
                            backgroundColor: 'transparent',
                            '& .MuiTab-root': {
                                transition: 'color 250ms',
                                color: (theme) => theme.palette.text.secondary,
                            },
                            '& .Mui-selected': {
                                color: (theme) => theme.palette.secondary.main,
                            },
                            '& .MuiTab-textColorSecondary.Mui-selected': {
                                backgroundColor: (theme) => theme.palette.primary.main,
                                borderRadius: "5px",
                                color: (theme) => theme.palette.common.white,
                            },
                            '& .MuiTab-textColorSecondary:hover': {
                                color: (theme) => theme.palette.primary.main,
                            },
                            '& .MuiTab-textColorSecondary:focus': {
                                color: (theme) => theme.palette.common.white,
                            },
                        }}
                    >
                        <Tab value={0} label="Profile" />

                        <Tab value={1} label="Edit" />
                    </Tabs>
                </CenteredBox>

                <TabPanel value={value} index={0}>
                    <ViewProfile admin={admin} />
                </TabPanel>

                <TabPanel value={value} index={1}>
                    <EditProfile admin={admin} onFetchAdmin={onFetchAdmin} />
                </TabPanel>


            </Card>
        </>
    )
}

export default Details